import { selectResourceInfo } from "../../../balancingSelectors/selectBalancingResources";
import { getResourceIcon } from "./getResourceIcon";
export var getResourceIconInfo = function (item) {
    var resourceInfo = selectResourceInfo(item.typeId);
    var tooltipLoca = resourceInfo.locaKey;
    return {
        amount: item.amount,
        icon: getResourceIcon(resourceInfo),
        tooltipLoca: tooltipLoca,
    };
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/icon/getResourceIconInfo.ts
// module id = 134
// module chunks = 3